import About from './dental/About';
import Contact from './dental/Contact';
import Gallery from './dental/Gallery';
import Home from './dental/Home';
import News from './dental/News';
import Newsdetail from './dental/Newsdetail';
import Service from './dental/Service';
import Servicedetails from './dental/Servicedetails';
import { Route,Routes,BrowserRouter } from 'react-router-dom';
import Video from './dental/Video';
import Login from './adminpanel/Login';
import Dashboard from './adminpanel/Dashboard';
import ProtectedRoute from "./adminpanel/ProtectedRoute";
import Photo from './adminpanel/Photo';
import Videoadmin from './adminpanel/Video';
import Serviceadmin from './adminpanel/Service';
import Newsadmin from './adminpanel/News';
import ChangePassword from './adminpanel/Changepass';
import Appointment from './dental/Appointment';




function App() {
  return (
    <div className="App">
      <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/about" element={<About/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/service" element={<Service/>}/>
          <Route path="/servicedetails/:id" element={<Servicedetails/>}/>
          <Route path="/photo" element={<Gallery/>}/>
          <Route path='/news' element={<News/>}/>
          <Route path='/newsdetails/:id' element={<Newsdetail/>}/>
          <Route path='/video' element={<Video/>}/>
          <Route path='/appointment' element={<Appointment/>}/>
          <Route path='/admin/login' element={<Login/>}/>
          <Route path='/admin/dashboard' element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>
          <Route path='/admin/photo' element={<ProtectedRoute><Photo/></ProtectedRoute>}/>
          <Route path='/admin/video' element={<ProtectedRoute><Videoadmin/></ProtectedRoute>}/>
          <Route path='/admin/service' element={<ProtectedRoute><Serviceadmin/></ProtectedRoute>}/>
          <Route path='/admin/news' element={<ProtectedRoute><Newsadmin/></ProtectedRoute>}/>
          <Route path='/admin/changepassword' element={<ProtectedRoute><ChangePassword/></ProtectedRoute>}/>
      </Routes>
    </div>
  );
}

export default App;
